import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  padding: 12px 20px;\n  font-size: 16px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  gap: 8px;\n  @media (max-width: 768px) {\n    flex-direction: column;\n    gap: 8px;\n    .ant-btn {\n      margin-inline-start: 0px !important;\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import BooksOrderModal from "@/components/Books/Order/BooksOrderModal";
import React from "react";
import styled from "styled-components";
import FilledButton from "../Button/FilledButton";
import { REGISTRATION_PAGE } from "@/settings/constant";
import FilledLink from "../Link/FilledLink";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import useRedirect from "@/hooks/useRedirect";
import { useRouter } from "next/router";
export const LoginModal = (param)=>{
    let { isOpen , close  } = param;
    const { redirectToLogin  } = useRedirect();
    const { asPath  } = useRouter();
    return /*#__PURE__*/ _jsx(BooksOrderModal, {
        severity: null,
        onClose: close,
        open: isOpen,
        title: "로그인이 필요해요",
        content: "로그인 혹은 회원가입을 진행해 주세요.",
        footer: /*#__PURE__*/ _jsxs(ModalFooter, {
            children: [
                /*#__PURE__*/ _jsx(FilledButton, {
                    type: "text",
                    variant: "soft",
                    onClick: ()=>{
                        close();
                        mixpanelEvent("Popup Button Clicked", {
                            "Popup Type": "login or signup",
                            "Popup Title": "로그인이 필요해요",
                            "Button Name": "로그인",
                            "Button URL": "/login"
                        });
                        redirectToLogin();
                    },
                    children: "로그인"
                }),
                /*#__PURE__*/ _jsx(FilledLink, {
                    variant: "solid",
                    onClick: ()=>{
                        close();
                        mixpanelEvent("Popup Button Clicked", {
                            "Popup Type": "login or signup",
                            "Popup Title": "로그인이 필요해요",
                            "Button Name": "회원가입",
                            "Button URL": "/signup"
                        });
                    },
                    href: "".concat(REGISTRATION_PAGE, "?redirectPath=").concat(asPath),
                    children: "회원가입"
                })
            ]
        })
    });
};
const ModalFilledButton = styled(FilledButton).withConfig({
    componentId: "sc-b70e1b5b-0"
})(_templateObject());
const ModalFooter = styled.div.withConfig({
    componentId: "sc-b70e1b5b-1"
})(_templateObject1());
